/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Status_CountingInputs */

const vi_stocktake_status_counting = /** @type {(inputs: Stocktake_Status_CountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang kiểm`)
};

/**

* @param {Stocktake_Status_CountingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_status_counting = /** @type {((inputs?: Stocktake_Status_CountingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Status_CountingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_status_counting(inputs)
});